export default __webpack_public_path__ + "static/media/img-0787-portugal-half-face.40c03a65.png";